import React, { useState } from "react";
// import { makeStyles } from "@material-ui/core";
import { Influencer } from "../../@types";

import SendMailForm from "./SendMailForm";
import api from "../../network/api";
// import { Message } from "../../@types";
import { toast } from "react-toastify";
import SaveIcon from "../SVGIcons/SaveIcon";
import validator from "validator";
import CircularLoading from "../Animations/Loading";
import logo from "../../assets/images/mochi-logo.png";
import { Image } from "semantic-ui-react";

import "reactjs-popup/dist/index.css";
import MoreHorizontal from "../SVGIcons/MoreHorizontal";
import format from "date-fns/format";

// const useStyles = makeStyles((theme) => ({
//   noteHeading: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//   },
//   note: {
//     minHeight: "12vh",
//     background: "#fff",
//     borderRadius: "10px",
//     padding: 0,
//     margin: 0,
//   },
//   icon: {
//     color: "#000",
//     background: "#fff",
//     marginRight: "1rem",
//     borderRadius: "5px",
//     height: "2.4rem",
//     "&:hover": {
//       color: "#000",
//       background: "#fff",
//     },
//   },
//   templateBottom: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "flex-end",
//     marginTop: "1rem",
//   },
//   sendBtn: {
//     border: "none",
//     background: "#ffcc00",
//     fontWeight: "bold",
//     padding: ".75rem 2rem",
//     color: "#000",
//     borderRadius: "10px",
//   },
//   daysRemaining: {
//     fontWeight: "bold",
//     textAlign: "center",
//     fontSize: "17px",
//   },
//   resendButton: {
//     border: "none",
//     background: "#ffcc00",
//     fontWeight: "bold",
//     padding: ".75rem 2rem",
//     color: "#000",
//     borderRadius: "10px",
//     cursor: "pointer",
//   },
// }));

interface Props {
  user?: Influencer;
  initconversations: any[];
  loadingConversations: boolean;
}

const Correspondence: React.FC<Props> = ({
  user,
  initconversations,
  loadingConversations,
}: Props) => {
  // const [editNote, setEditNote] = React.useState(false);
  // const [sendMailShown, setSendMailShown] = React.useState(false);
  const [refreshCount, setRefreshCount] = React.useState(0);
  const [subject, setSubject] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [isSavingEmail, setIsSavingEmail] = React.useState(false);
  const [email, setEmail] = React.useState(user?.email || "");
  let [conversations, setConversations] = useState<any>([]);
  const [emailPaginationCount, setEmailPaginationCount] = useState(2);

  let [showFooter, setShowFooter] = useState(-1);

  let signature =
    '<div><br clear="all"><div><br></div><br><div dir="ltr" class="gmail_signature" data-smartmail="gmail_signature"><div dir="ltr"><div style="font-size:12.7273px;font-family:arial"><table cellspacing="0" cellpadding="0" border="0" style="font-family:Montserrat,sans-serif;font-size:17px;width:500px;color:gray"><tbody><tr><td style="margin:0.1px"><img src="https://img.mysignature.io/a/v1/d/b/f/dbf4e6ef-1433-5fa8-9df2-337aa6bb6077.png?uid=3185811621501736299" alt="Best regards," style="vertical-align:middle;border-style:none;max-width:100%;padding-bottom:5px"></td></tr></tbody></table><div style="color:rgb(72,101,137);font-family:Montserrat,sans-serif;font-size:17px"><table cellspacing="0" width="500" cellpadding="0" border="0"><tbody><tr><td width="137" valign="top" style="padding:0px 9px 0px 0px;vertical-align:top"><a href="http://www.learnwithmochi.com/" target="_blank"><img alt="www.learnwithmochi.com" width="137" src="https://img.mysignature.io/p/c/3/d/c3d95dbf-3d54-5342-a47b-590397649387.png?time=1621501669" style="vertical-align:middle;border-style:none;max-width:137px;width:137px;border-radius:0%"></a></td><td valign="top" style="margin:0.1px;border-left:2px solid rgb(246,68,64);vertical-align:top;border-top-color:rgb(246,68,64);border-right-color:rgb(246,68,64);border-bottom-color:rgb(246,68,64);padding:0px 0px 0px 9px"><table cellspacing="0" cellpadding="0" border="0" style="line-height:1.4;font-family:Verdana,Geneva,sans-serif;font-size:15.3px;color:rgb(0,0,1)"><tbody><tr><td style="margin:0.1px"><span style="font-stretch:normal;font-size:1.2em;line-height:normal;font-family:Verdana,Geneva,sans-serif;color:rgb(246,68,64)">Mochi Bear</span><span style="font-family:Verdana,Geneva,sans-serif"></span></td></tr><tr><td style="margin:0.1px;padding:5px 0px"><div style="font-family:Verdana,Geneva,sans-serif">Learn With Mochi</div></td></tr><tr><td style="margin:0.1px"><span style="font-family:Verdana,Geneva,sans-serif">w:</span><span style="font-family:Verdana,Geneva,sans-serif"><a href="http://www.learnwithmochi.com/" style="background-color:transparent;color:rgb(0,0,1)" target="_blank">www.learnwithmochi.com</a></span></td></tr><tr><td style="margin:0.1px"><span style="font-family:Verdana,Geneva,sans-serif">e:</span><a href="mailto:social@learnwithmochi.com" style="background-color:transparent;font-family:Verdana,Geneva,sans-serif;color:rgb(0,0,1)" target="_blank">social@learnwithmochi.com</a></td></tr><tr><td style="margin:0.1px;padding:8px 0px 3px;display:block"><div style="font-family:Verdana,Geneva,sans-serif"></div></td></tr><tr><td style="margin:0.1px"><table cellspacing="0" cellpadding="0" border="0"><tbody><tr><td style="font-family:Arial;margin:0.1px;padding:0px 4px 0px 0px"><a href="https://mysignature.https//www.youtube.com/channel/UC2rbhYu9Ys0zYcLEH91oqRQio/"style="background-color:transparent" target="_blank"><img alt="created with MySignature.io" width="23" src="https://img.mysignature.io/s/v3/9/8/8/9884a803-521f-5ee2-8465-81a9ac113794.png" style="vertical-align:middle;border-style:none;max-width:100%;width:23px;min-width:23px"></a></td><td style="font-family:Arial;margin:0.1px;padding:0px 4px 0px 0px"><a href="https://mysignature.io/https://www.instagram.com/mochithebear/" style="background-color:transparent" target="_blank"><img alt="created with MySignature.io" width="23" src="https://img.mysignature.io/s/v3/d/1/0/d10a8dfc-ad95-568c-a2c4-d9ef219393f2.png" style="vertical-align:middle;border-style:none;max-width:100%;width:23px;min-width:23px"></a></td><td style="font-family:Arial;margin:0.1px;padding:0px 4px 0px 0px"><a href="https://www.facebook.com/LearnWithMochi" style="background-color:transparent" target="_blank"><img alt="created with MySignature.io" width="23" src="https://img.mysignature.io/s/v3/2/2/9/22931985-da96-5ffb-8449-4ec6b99c9a1f.png" style="vertical-align:middle;border-style:none;max-width:100%;width:23px;min-width:23px"></a></td><td style="font-family:Arial;margin:0.1px;padding:0px 4px 0px 0px"><a href="https://twitter.com/LearnWithMochi" style="background-color:transparent" target="_blank"><img alt="created with MySignature.io" width="23" src="https://img.mysignature.io/s/v3/8/7/6/87699f83-797a-5947-bc32-2052a55e7068.png" style="vertical-align:middle;border-style:none;max-width:100%;width:23px;min-width:23px"></a></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table><table width="500" cellspacing="0" cellpadding="0" border="0"><tbody><tr style="font-size:1px"><td colspan="2" style="font-size:0px"><a href="https://mysignature.io/editor/?utm_source=freepixel" style="background-color:transparent" target="_blank"><img src="https://img.mysignature.io/pixel/1135459/signature/318581" style="vertical-align:middle;border-style:none;max-width:100%"></a></td></tr></tbody></table></div><table cellspacing="0" cellpadding="0" border="0" style="width:500px;color:gray;font-family:Arial;line-height:1;font-size:12px"><tbody><tr><td style="margin:0.1px;padding-top:5px"></td></tr></tbody></table><table style="color:rgb(72,101,137);font-family:Montserrat,sans-serif;font-size:17px"><tbody><tr><td style="margin:0.1px;display:block;padding:15px 0px 0px"></td></tr><tr><td style="font-family:Arial;margin:0.1px;border-top:1px solid rgb(238,238,238);padding-top:5px;font-size:10px"><br></td></tr></tbody></table><table style="color:rgb(72,101,137);font-family:Montserrat,sans-serif;font-size:17px"><tbody><tr><td style="margin:0.1px;line-height:1px;font-size:1px;height:1px">=C2=A0</td></tr></tbody></table><span style="font-size:12.7273px;background-color:transparent"></span><a href="http://learnwithmochi.com/" style="background-color:transparent;font-family:&quot;trebuchet ms&quot;,sans-serif;font-size:small;color:rgb(17,85,204)" target="_blank">Inspiring the creators of tomorrow</a></div></div></div></div>';

  conversations = initconversations;

  // const classes = useStyles();

  const sendMail = async () => {
    if ((!subject && conversations.length < 1) || !message) {
      toast.error("Subject and message are required!");
      return;
    }

    try {
      setLoading(true);
      const res = await api.post(`/messages`, {
        
        email: email,
        influencerId: user?.id,
        message: message,
        html: message + signature,
        subject: subject || conversations[0]["subject"],
      }, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
        },
      });

      //push to local list
      console.log(res);
      console.log("response");
      conversations.push({
        email: "me:" + email,
        influencerId: user?.id,
        text: message,
        html: message,
        subject: subject || conversations[0]["subject"],
        created_at: Date.now(),
      });
      toast.success("Sent mail!");
      setRefreshCount(refreshCount + 1);
      setLoading(false);
    } catch (error) {
      toast.error("Unable to send mail, please try again!");
      setLoading(false);
    }
  };

  const saveEmailField = async (id: number, email: string) => {
    setIsSavingEmail(true);
    console.log(id);
    if (!email || !validator.isEmail(email)) {
      toast.error("Please enter a valid email");
      return;
    }
    try {
      await api.put(`/update-instagram-profile/${id}`, { email },{  headers: {
        Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
      },});
      toast.success("Updated email field");
    } catch (error) {
      toast.error("Unable to update the email address");
    }
    setIsSavingEmail(false);
  };

  // const getDaysRemaining = React.useCallback(() => {
  //   if (messages.length === 1) {
  //     const lastDate = new Date(messages[0].created_at);
  //     const daysRemaining =
  //       (new Date().getTime() - lastDate.getTime()) / (1000 * 3600 * 24);
  //     return {
  //       days: Math.round(daysRemaining),
  //       shouldRender: Math.round(daysRemaining) >= 7,
  //     };
  //   }
  //   return { shouldRender: false };
  // }, [messages]);

  React.useEffect(() => {
    setConversations(initconversations);
  }, [initconversations]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginLeft: "3rem",
          marginTop: "3rem",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              color: "white",
              width: "100%",
              height: "300px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {loadingConversations ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {" "}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                      flexDirection: "column",
                      opacity: loadingConversations ? "1" : "0",
                      transition: "all 0.3s ease",
                      transform: loadingConversations
                        ? "translateY(-40px)"
                        : "translateY(20vh)",
                    }}
                  >
                    <CircularLoading />
                  </div>
                  <p style={{ transform: "translate(-55px,40px)" }}>
                    {" "}
                    Loading conversations
                  </p>
                </div>
              ) : (
                <div>
                  {conversations.length >= 1 ? (
                    <div>
                      <div
                        style={{
                          fontSize: "1.1rem",
                          // color: "#ffcc00",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >{`Conversation with ${user?.email}`}</div>
                      <div
                        style={{
                          width: "100%",
                          backgroundColor: "white",
                          marginBlock: "10px",
                          height: "2px",
                          borderRadius: "10px",
                        }}
                      ></div>
                      <div
                        style={{
                          fontSize: "1rem",
                          color: "#ffcc00",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {conversations[0]["subject"]
                          .toString()
                          .replace("Re:", "")}
                      </div>
                      <div
                        style={{
                          // width: "100%",
                          backgroundColor: "white",
                          marginBlock: "10px",
                          marginBottom: "30px",
                          height: "2px",
                          borderRadius: "10px",
                        }}
                      ></div>
                      <div
                        style={{
                          display:
                            emailPaginationCount === conversations.length
                              ? "none"
                              : "flex",
                          justifyContent: "center",
                        }}
                      >
                        <p
                          onClick={() => {
                            conversations.length - emailPaginationCount > 2
                              ? setEmailPaginationCount(
                                  emailPaginationCount + 2
                                )
                              : setEmailPaginationCount(
                                  emailPaginationCount +
                                    (conversations.length -
                                      emailPaginationCount)
                                );
                          }}
                          style={{
                            backgroundColor: "#ffcc00",
                            color: "black",
                            borderRadius: "10px",
                            cursor: "pointer",
                            paddingBlock: "10px",
                            paddingInline: "12px",
                          }}
                        >
                          Load More
                        </p>
                      </div>
                      {conversations
                        .slice(
                          conversations.length - emailPaginationCount,
                          conversations.length
                        )
                        .map((conversation: any, index: number) => {
                          let trimmedMessage = ''
                          let trimmedFooter = ''

                          if (conversation.email !== user?.email) {
                            trimmedMessage = conversation.text;
                            trimmedFooter = "";
                          } else{
                             trimmedMessage =
                            conversation.html
                              .toString()
                              .split('<div class="gmail_quote">')[0] || "";
                           trimmedFooter =
                            conversation.html
                              .toString()
                              .split('<div class="gmail_quote">')[1] || "";
                          }

                          return (
                            <div
                              key={index}
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent:
                                  conversation.email === `${user?.email}`
                                    ? "start"
                                    : "end",
                              }}
                            >
                              <div
                                style={{
                                  display:
                                    conversation.email === `${user?.email}`
                                      ? "flex"
                                      : "none",
                                  flexDirection: "column",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    backgroundColor: "#ffcc00",
                                    borderRadius: "50%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: "black",
                                    marginTop: "20px",
                                    marginInline: "20px",
                                    fontSize: "1.8rem",
                                  }}
                                >
                                  {user?.email.substring(0, 1)}
                                </div>

                                <p
                                  style={{
                                    fontSize: "0.7rem",
                                  }}
                                >
                                  {format(
                                    new Date(conversation.created_at),
                                    "dd-MM-yyyy"
                                  )}
                                </p>
                              </div>

                              <p
                                style={{
                                  maxWidth: "65%",
                                  color: "black",
                                  backgroundColor:
                                    conversation.email === `${user?.email}`
                                      ? "white"
                                      : "white",

                                  borderRadius: "10px",
                                  padding: "10px",
                                }}
                              >
                                <div>
                                  {" "}
                                  {conversation.email === `${user?.email}` && (
                                    <div>
                                      <div
                                        style={{
                                          fontWeight: "bold",
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                      >
                                        {`${user?.first_name} ${user?.last_name} `}
                                      </div>
                                      {`<${user?.email}>`}
                                      <br />
                                      <div
                                        style={{
                                          width: "100%",
                                          backgroundColor: "#ffcc00",
                                          marginBottom: "10px",
                                          height: "2px",
                                          borderRadius: "10px",
                                        }}
                                      ></div>
                                    </div>
                                  )}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: trimmedMessage,
                                    }}
                                    style={{
                                      margin: "10px",
                                      borderRadius: "10px",
                                    }}
                                  ></div>
                                  <div
                                    onClick={() =>
                                      showFooter === index
                                        ? setShowFooter(-1)
                                        : setShowFooter(index)
                                    }
                                    style={{
                                      // margin: "10px",
                                      height: "20px",
                                      display:
                                        trimmedFooter.length > 0
                                          ? "block"
                                          : "none",
                                      width: "20px",
                                      cursor: "pointer",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    {" "}
                                    <MoreHorizontal />
                                  </div>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: trimmedFooter,
                                    }}
                                    style={{
                                      margin: "10px",
                                      borderRadius: "10px",
                                      // height: showFooter === index ? "500px" : "0px",
                                      display:
                                        showFooter === index ? "block" : "none",
                                      opacity: showFooter === index ? "1" : "0",
                                      transition: "all 0.2s ease-out",
                                    }}
                                  ></div>
                                  <div
                                    style={{
                                      // margin: "10px",
                                      height: "20px",
                                      width: "20px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {" "}
                                  </div>
                                </div>
                              </p>
                              <div
                                style={{
                                  flexDirection: "column",
                                  alignItems: "center",
                                  display:
                                    conversation.email === `${user?.email}`
                                      ? "none"
                                      : "flex",
                                }}
                              >
                                <div
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    backgroundColor: "#ffcc00",
                                    borderRadius: "50%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: "black",
                                    marginTop: "20px",
                                    marginInline: "20px",
                                    fontSize: "1.8rem",
                                  }}
                                >
                                  <Image className="small-logo" src={logo} />
                                </div>

                                <p
                                  style={{
                                    fontSize: "0.7rem",
                                  }}
                                >
                                  {format(
                                    new Date(conversation.created_at),
                                    "dd-MM-yyyy"
                                  )}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "2rem",
                      }}
                    >
                      No conversation started
                    </div>
                  )}
                </div>
              )}
            </div>
            <div
              style={{
                display: conversations.length > 0 ? "none" : "flex",

                flexDirection: "row",
                alignItems: "center",
              }}
            >
              Send to
              <input
                placeholder="Enter email"
                style={{
                  paddingInline: "20px",
                  marginLeft: "20px",
                  paddingBlock: "10px",
                  width: "20rem",
                  borderRadius: "10px",
                  backgroundColor: "#e9f4f9",
                  color: "black",
                  fontWeight: "bold",
                }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <div>
                <div
                  style={{
                    marginInline: "20px",
                    position: "absolute",
                    opacity: isSavingEmail ? "1" : "0",
                    transition: "all 0.2s ease",
                    transform: isSavingEmail
                      ? "translateY(0px)"
                      : "translateY(20px)",
                    marginBottom: "30px",
                  }}
                >
                  <CircularLoading />
                </div>
                <div
                  onClick={() => saveEmailField(user!.id, email)}
                  style={{
                    marginLeft: "1rem",
                    height: "25px",
                    width: "25px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    opacity: isSavingEmail ? "0" : "1",
                    transform: isSavingEmail
                      ? "translateY(-20px)"
                      : "translateY(0px)",
                  }}
                >
                  <SaveIcon />
                </div>
              </div>
            </div>
            {/* {messages.map((message) => (
            <SendMailForm
              subject={message.subject}
              message={message.message}
              isOld
            />
          ))}
          {typeof getDaysRemaining().days !== "undefined" && (
            <>
              <p className={classes.daysRemaining}>
                {getDaysRemaining().days} days since last email sent
              </p>
              {getDaysRemaining().shouldRender && (
                <button
                  className={classes.resendButton}
                  onClick={() => setSendMailShown(true)}
                >
                  Resend
                </button>
              )}
            </>
          )} */}
            {/* {(sendMailShown || !messages.length) && ( */}
            {
              <div
                style={{
                  width: "100%",
                  display: "block",
                  justifyContent: "center",
                  paddingBottom:"100px"
                }}
              >
                <SendMailForm
                  subject={subject}
                  message={message}
                  user={user}
                  loading={loading}
                  showSubjectLine={conversations.length === 0}
                  setSubject={setSubject}
                  setMessage={setMessage}
                  sendMail={sendMail}
                />
              </div>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default Correspondence;
